import { AxiosError, AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { QueryKeys } from "../common/types";
import { client } from "../common/services";
import { MarkupConditionItem, PagedResponse } from "@bandido/shared";

interface GetMarkupRulesListResponse {
  id: string;
  name: string;
  servicetype: string;
  order: number;
  type: string;
  value: number;
  isactive: boolean;
  createdAt: string;
  updatedAt: string;

}

interface UseGetMarkupRulesByAgencyIdProps {
  agencyId?: number;
  onErrorCallback?: (_e: AxiosError) => void;
}

export const useGetMarkupRulesByAgencyId = ({ agencyId, onErrorCallback }: UseGetMarkupRulesByAgencyIdProps) =>
  useQuery({
    queryKey: [QueryKeys.getMarkupRulesByAgencyId, agencyId],
    queryFn: async (): Promise<PagedResponse<GetMarkupRulesListResponse & { conditionCount: number; }> | undefined> => {
      try {
        const result: AxiosResponse<PagedResponse<GetMarkupRulesListResponse & { conditionCount: number; }>, any> = await client.get(`markup-rules/agency/${agencyId}`);

        return result.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
    enabled: Boolean(agencyId),
  });

interface UseGetMarkupRulesByIdProps {
  id?: string;
  onErrorCallback?: (_e: AxiosError) => void;
}

export const useGetMarkupRulesById = ({ id, onErrorCallback }: UseGetMarkupRulesByIdProps) =>
  useQuery({
    queryKey: [QueryKeys.getMarkupRulesByAgencyId, id],
    queryFn: async (): Promise<GetMarkupRulesListResponse & { conditions: MarkupConditionItem[] } | undefined> => {
      try {
        const result: AxiosResponse<GetMarkupRulesListResponse & { conditions: MarkupConditionItem[] }, any> = await client.get(`markup-rules/${id}`);

        return result.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
    enabled: (id !== 'create' && Boolean(id)),
  });
